import { AuthService } from "src/app/auth/auth.service";

export const AppAuthInjector = (authService: AuthService) => {
  return ()=> authService.initToken();
}